module.exports = __webpack_public_path__ + "assets/img/simplybrand-metrics.5c0570e2.png";